import { Payoff, Refloor } from "../../common/PayoffRefloorPills"
import HighlightMatch from "../../../utilities/HighlightMatch"
import formatter from "../../../constants/currencyFormatter"
import useStore from "../../../store"
import { useTranslation } from "react-i18next"

export default function UnitPayoffRefloor({ unit, filter }) {
  const setPaymentType = useStore((state) => state.setPaymentType)
  const { t } = useTranslation()

  return(
    <div className="flex justify-evenly items-center w-full">
      <div>
        <Payoff />
        <div onClick={() => setPaymentType(1) }>
          <Refloor />
        </div>
      </div>
      <div className="text-right text-grey-100">
        <div><HighlightMatch str={formatter.format(unit.attributes.payoff)} match={filter} /></div>
        {unit?.attributes['refloor-allowed'] ?
          <div><HighlightMatch str={formatter.format(unit.attributes.curtailment)} match={filter} /></div>
        :
          <div className="text-fpx-red text-sm">{t("Max Refloor")}</div>
        }
      </div>
    </div>
  )
}